<template>
  <div class="space-x-3 flex items-center">
    <SwitchLanguage />
    <RouterLink
      v-if="'accountId' in $route.params"
      :to="{ name: 'accounts.accountId.settings' }"
      class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
        />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    </RouterLink>
    <Notifications />
    <VDropdown theme="ghost" placement="bottom-end">
      <!-- This will be the popover target (for the events and position) -->
      <button
        class="max-w-xs bg-white rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <img
          class="h-8 w-8 rounded-full"
          :src="`https://eu.ui-avatars.com/api/?name=${$user.fullName}`"
          alt=""
        />
        <span class="hidden lg:block ml-3 text-gray-700 text-xs font-medium"
          ><span class="sr-only">Open user menu for </span>{{ $user.fullName }}</span
        >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          class="hidden flex-shrink-0 ml-1 h-5 w-5 text-gray-400 lg:block"
        >
          <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
        </svg>
      </button>
      <!-- This will be the content of the popover -->
      <template #popper>
        <ul class="py-1 w-64">
          <li v-if="$user && $isAdminOrSuperAdmin">
            <RouterLink
              v-close-popper
              :to="{ name: 'admin' }"
              class="text-gray-700 hover:text-gray-900 hover:bg-gray-100 block px-4 py-2 text-sm"
            >
              {{ $t('Admin') }}
            </RouterLink>
          </li>
          <li v-if="$user && $isAdminOrSuperAdmin">
            <a
              v-close-popper
              href="/v2/admin/accounts"
              class="text-gray-700 hover:text-gray-900 hover:bg-gray-100 block px-4 py-2 text-sm"
            >
              Admin v2
            </a>
          </li>
          <li>
            <RouterLink
              v-close-popper
              :to="{ name: 'logout' }"
              class="text-gray-700 hover:text-gray-900 hover:bg-gray-100 block px-4 py-2 text-sm"
            >
              {{ $te('Logout') ? $t('Logout') : 'Logout' }}
            </RouterLink>
          </li>
        </ul>
      </template>
    </VDropdown>
  </div>
</template>

<script>
import Notifications from './Notifications.vue';
import SwitchLanguage from './SwitchLanguage.vue';

export default {
  name: 'QuickMenu',
  components: {
    Notifications,
    SwitchLanguage,
  },
  computed: {
    membershipRoleNames() {
      return this.$membershipRoles.map((role) => role.name).join(', ');
    },
  },
};
</script>
